import React from 'react';

/**
 * Renders the list of registered agents in the sidebar.
 * 
 * @param {object} props - Component props.
 * @param {Array} props.agents - Array of agent objects to display.
 */
export default function AgentList({ agents }) {
    if (!agents || agents.length === 0) {
        return <p className="text-sm text-gray-600">No agents registered yet.</p>;
    }

    return (
        <ul className="space-y-2">
            {agents.map((agent, index) => {
                // Support both camelCase and snake_case attributes
                const agentId = agent.agent_id || agent.AgentId || `agent-${index}`;
                const agentStatus = agent.status || agent.Status || 'UNKNOWN';
                const statusColorClass = agentStatus.toUpperCase() === 'ONLINE' 
                    ? 'text-green-600' 
                    : 'text-gray-500';

                return (
                    <li key={agentId} className="bg-white p-2 border rounded-md shadow-sm text-sm break-words">
                        <p className="font-medium text-gray-700 truncate" title={`Agent ID: ${agentId}`}>
                            Agent ID: {agentId}
                        </p>
                        <p className={`text-xs ${statusColorClass}`}>
                            Status: {agentStatus.toUpperCase()}
                        </p>
                        {/* Placeholder for future actions */}
                        {/* 
                        <div className="mt-1 flex justify-end">
                             <button className="text-xs text-blue-500 hover:underline">Details</button>
                        </div> 
                        */}
                    </li>
                );
            })}
        </ul>
    );
}